import React from "react";
import "./App.scss";
import Routing from "./Routes";
import './types/chartConfig'; 

const App = () => {

  return <Routing />;
};

export default App;
